<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 简历 -->
        <div class="resume row">
            <div :class="guding ? 'resume_l2 colum' : 'resume_l column'">
                <!-- <img src="@/assets/images/jianlimulu.png" alt="" style="width: 100%;"> -->
                <div class="resume_l_top">简历目录</div>
                <div class="resume_l_main column">
                    <div class="resume_l_main_m" @click="link(1)">个人信息</div>
                    <div class="resume_l_main_m" @click="link(2)">个人优势</div>
                    <div class="resume_l_main_m" @click="link(3)">期望职位</div>
                    <div class="resume_l_main_m" @click="link(4)">工作经历</div>
                    <div class="resume_l_main_m" @click="link(5)">项目经历</div>
                    <div class="resume_l_main_m" @click="link(6)">教育经历</div>
                </div>
            </div>
            <div :class="guding ? 'resume_m2 column' : 'resume_m column'">
                <!-- <img src="@/assets/images/jianli1.png" alt="" style="width: 100%;"> -->
                <div class="resume_m_top row">
                    <div class="resume_m_top_l">我的简历</div>
                </div>
                <div class="resume_m_m" v-if="resumeFileList.length > 0">
                    <!-- 个人信息 -->
                    <div id="gerenxinxi" class="resume_m_m_gerenxinxi row">
                        <div class="resume_m_m_gerenxinxi_l column">
                            <div class="resume_m_m_gerenxinxi_l_name">{{ zaixianjianli.name }}</div>
                            <div class="resume_m_m_gerenxinxi_l_jianjie row">
                                <div class="resume_m_m_gerenxinxi_l_jianjie_m" v-if="zaixianjianli.workYear">
                                    <i class="el-icon-s-cooperation"></i>
                                    <span>{{ zaixianjianli.workYear }}年经验</span>
                                </div>
                                <div class="resume_m_m_gerenxinxi_l_jianjie_m" v-if="zaixianjianli.educationName">
                                    <i class="el-icon-s-home"></i>
                                    <span>{{ zaixianjianli.educationName }}</span>
                                </div>
                            </div>
                            <div class="resume_m_m_gerenxinxi_l_jianjie row">
                                <div class="resume_m_m_gerenxinxi_l_jianjie_m" v-if="zaixianjianli.mobile">
                                    <i class="el-icon-mobile-phone"></i>
                                    <span>{{ zaixianjianli.mobile }}</span>
                                </div>
                                <div class="resume_m_m_gerenxinxi_l_jianjie_m" v-if="zaixianjianli.wechat">
                                    <i class="el-icon-chat-dot-round"></i>
                                    <span>{{ zaixianjianli.wechat }}</span>
                                </div>
                                <div class="resume_m_m_gerenxinxi_l_jianjie_m" v-if="zaixianjianli.email">
                                    <i class="el-icon-message"></i>
                                    <span>{{ zaixianjianli.email }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="resume_m_m_gerenxinxi_r">
                            <img src="@/assets/images/resumeheader.jpg">
                        </div> -->
                    </div>
                    <!-- 个人优势 -->
                    <div id="gerenyoushi" class="resume_m_m_main column">
                        <div class="resume_m_m_main_top row">
                            <div class="resume_m_m_main_top_l"></div>
                            <div class="resume_m_m_main_top_r">个人优势</div>
                        </div>
                        <div class="resume_m_m_main_m">
                            <div class="resume_m_m_main_m_gerenyoushi" v-if="!zaixianjianli.advantage">
                                {{ zaixianjianli.advantage }}
                            </div>
                            <div class="resume_m_m_main_m_gerenyoushi" v-else style="color: #999;">
                                暂无信息
                            </div>
                        </div>
                    </div>
                    <!-- 期望职位 -->
                    <div id="qiwangzhiwei" class="resume_m_m_main column">
                        <div class="resume_m_m_main_top row">
                            <div class="resume_m_m_main_top_l"></div>
                            <div class="resume_m_m_main_top_r">期望职位</div>
                        </div>
                        <div class="resume_m_m_main_m">
                            <div class="resume_m_m_main_m_qiwangzhiwei column"
                                v-if="zaixianjianli.expectJob || zaixianjianli.expectSalary || zaixianjianli.expectedAreaNames">
                                <!-- <div class="resume_m_m_main_m_qiwangzhiwei_top">全职职位</div> -->
                                <div class="resume_m_m_main_m_qiwangzhiwei_bottom row">
                                    <div class="resume_m_m_main_m_qiwangzhiwei_bottom_zhiwei"
                                        v-if="zaixianjianli.expectJob">
                                        {{ zaixianjianli.expectJob }}
                                    </div>
                                    <span v-if="zaixianjianli.expectSalary">|</span>
                                    <div class="resume_m_m_main_m_qiwangzhiwei_bottom_xinzi"
                                        v-if="zaixianjianli.expectSalary">
                                        {{ zaixianjianli.expectSalary }}k</div>
                                    <span v-if="zaixianjianli.expectedAreaNames">|</span>
                                    <div class="resume_m_m_main_m_qiwangzhiwei_bottom_didian"
                                        v-if="zaixianjianli.expectedAreaNames">
                                        {{ zaixianjianli.expectedAreaNames }}
                                    </div>
                                </div>
                            </div>
                            <div class="resume_m_m_main_m_qiwangzhiwei column" v-else style="color: #999;">
                                暂无信息
                            </div>
                        </div>
                    </div>
                    <!-- 工作经历 -->
                    <div id="gongzuojingli" class="resume_m_m_main column">
                        <div class="resume_m_m_main_top row">
                            <div class="resume_m_m_main_top_l"></div>
                            <div class="resume_m_m_main_top_r">工作经历</div>
                        </div>
                        <div class="resume_m_m_main_m">
                            <div class="resume_m_m_main_m_gongzuojingli column"
                                v-for="(item, index) in zaixianjianli.workList" :key="index">
                                <div class="resume_m_m_main_m_gongzuojingli_top row">
                                    <div class="resume_m_m_main_m_gongzuojingli_top_l row">
                                        <div class="resume_m_m_main_m_gongzuojingli_top_title">
                                            {{ item.company }}
                                        </div>
                                        <div class="resume_m_m_main_m_gongzuojingli_top_job">
                                            {{ item.position }}
                                        </div>
                                    </div>
                                    <div class="resume_m_m_main_m_gongzuojingli_top_time">
                                        {{ item.startDate }}-{{ item.endDate }}
                                    </div>
                                </div>
                                <!-- <div class="resume_m_m_main_m_gongzuojingli_tabs row">
                                    <div class="resume_m_m_main_m_gongzuojingli_tabs_m">JQuery</div>
                                    <div class="resume_m_m_main_m_gongzuojingli_tabs_m">前端开发</div>
                                    <div class="resume_m_m_main_m_gongzuojingli_tabs_m">CSS3</div>
                                    <div class="resume_m_m_main_m_gongzuojingli_tabs_m">HTML5</div>
                                    <div class="resume_m_m_main_m_gongzuojingli_tabs_m">HTML</div>
                                    <div class="resume_m_m_main_m_gongzuojingli_tabs_m">CSS</div>
                                </div> -->
                                <div class="resume_m_m_main_m_gongzuojingli_main row">
                                    <div class="resume_m_m_main_m_gongzuojingli_main_l">内容：</div>
                                    <div class="resume_m_m_main_m_gongzuojingli_main_r">
                                        {{ item.description }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 项目经历 -->
                    <div id="xiangmujingli" class="resume_m_m_main column">
                        <div class="resume_m_m_main_top row">
                            <div class="resume_m_m_main_top_l"></div>
                            <div class="resume_m_m_main_top_r">项目经历</div>
                        </div>
                        <div class="resume_m_m_main_m" v-if="zaixianjianli.projectList.length > 0">
                            <div class="resume_m_m_main_m_xiangmujingli column"
                                v-for="(item, index) in zaixianjianli.projectList" :key="index">
                                <div class="resume_m_m_main_m_xiangmujingli_top row">
                                    <div class="resume_m_m_main_m_xiangmujingli_top_l row">
                                        <div class="resume_m_m_main_m_xiangmujingli_top_title">
                                            {{ item.project }}
                                        </div>
                                        <div class="resume_m_m_main_m_xiangmujingli_top_job">
                                            {{ item.title }}
                                        </div>
                                    </div>
                                    <div class="resume_m_m_main_m_xiangmujingli_top_time"
                                        v-if="item.startDate && item.endDate">
                                        {{ item.startDate }}-{{ item.endDate }}
                                    </div>
                                </div>
                                <div class="resume_m_m_main_m_xiangmujingli_main row">
                                    <div class="resume_m_m_main_m_xiangmujingli_main_l">内容：</div>
                                    <div class="resume_m_m_main_m_xiangmujingli_main_r">
                                        {{ item.detail }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="resume_m_m_main_m" v-else style="color: #999;">
                            暂无信息
                        </div>
                    </div>
                    <!-- 教育经历 -->
                    <div id="jiaoyujingli" class="resume_m_m_main column">
                        <div class="resume_m_m_main_top row">
                            <div class="resume_m_m_main_top_l"></div>
                            <div class="resume_m_m_main_top_r">教育经历</div>
                        </div>
                        <div class="resume_m_m_main_m">
                            <div class="resume_m_m_main_m_jiaoyujingli row" v-for="(item, index) in zaixianjianli.eduList"
                                :key="index">
                                <!-- <img class="resume_m_m_main_m_jiaoyujingli_img" src="@/assets/images/xuexiao.png"> -->
                                <div class="resume_m_m_main_m_jiaoyujingli_r column">
                                    <div class="resume_m_m_main_m_jiaoyujingli_r_top row">
                                        <div class="resume_m_m_main_m_jiaoyujingli_r_top_title" v-if="item.school">
                                            {{ item.school }}
                                        </div>
                                        <div class="resume_m_m_main_m_jiaoyujingli_r_top_time"
                                            v-if="item.startDate && item.endDate">
                                            {{ item.startDate }}-{{ item.endDate }}
                                        </div>
                                    </div>
                                    <div class="resume_m_m_main_m_jiaoyujingli_r_bottom row">
                                        <div class="resume_m_m_main_m_jiaoyujingli_r_bottom_l row" v-if="item.major">
                                            {{ item.major }}
                                        </div>
                                        <div class="resume_m_m_main_m_jiaoyujingli_r_bottom_r row"
                                            v-if="item.educationName">
                                            {{ item.educationName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="resume_m_m2" v-else>
                    暂无简历信息，请上传简历
                </div>
            </div>
            <div class="resume_r column">
                <div class="resume_r_jianli">
                    <!-- <img src="@/assets/images/gerenjianli.png" alt="" style="width: 100%;"> -->
                    <div class="resume_r_jianli_top row">
                        <div class="resume_r_jianli_top_title">附件管理</div>
                        <el-upload class="upload-demo" :action="fujianUrl" :disabled="resumeFileList.length > 2"
                            :data="uploadData" :headers="headers" :show-file-list="false" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                    <div class="resume_r_jianli_main column" v-loading="fileLoading">
                        <div class="resume_r_jianli_main_text">文件（{{ resumeFileList.length }}/3）</div>
                        <div class="resume_r_jianli_main_file row" v-for="(item, index) in resumeFileList" :key="index">
                            <img v-if="item.fileType == 'doc'" src="@/assets/images/icon-doc.png"
                                class="resume_r_jianli_main_file_img">
                            <img v-if="item.fileType == 'pdf'" src="@/assets/images/icon-pdf.png"
                                class="resume_r_jianli_main_file_img">
                            <div class="resume_r_jianli_main_file_r column">
                                <div class="resume_r_jianli_main_file_title">{{ item.fileName }}</div>
                                <div class="resume_r_jianli_main_file_xiangqing">{{ item.fileSize * 1024 }}KB 更新于
                                    {{ item.createTime.split('T')[0] }}</div>
                            </div>
                            <div class="resume_r_jianli_main_file_more column">
                                <div class="resume_r_jianli_main_file_more_dian">...</div>
                                <div class="resume_r_jianli_main_file_more_list column">
                                    <!-- <div class="resume_r_jianli_main_file_more_list_m">预览</div> -->
                                    <div class="resume_r_jianli_main_file_more_list_m" @click="shezhijianli(item)">
                                        设置为简历
                                    </div>
                                    <div class="resume_r_jianli_main_file_more_list_m" @click="xiazaijianli(item)">下载</div>
                                    <div class="resume_r_jianli_main_file_more_list_m" @click="chongmingmingjianli(item)">
                                        重命名
                                    </div>
                                    <div class="resume_r_jianli_main_file_more_list_m" @click="fileDel(item.id)">删除</div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="resume_r_jianli_main_file_wu" v-if="!resumeFileList2">
                            暂无简历
                        </div> -->
                    </div>
                </div>
                <div class="resume_r_yinsishezhi column">
                    <!-- <img src="@/assets/images/yinsishezhi.png" alt="" style="width: 100%;"> -->
                    <div class="resume_r_yinsishezhi_top row">
                        <div class="resume_r_yinsishezhi_top_l">隐私设置</div>
                        <div class="resume_r_yinsishezhi_top_r" @click="shezhi()">设置</div>
                    </div>
                    <div class="resume_r_yinsishezhi_main column">
                        <div class="resume_r_yinsishezhi_main_m row">
                            <div class="resume_r_yinsishezhi_main_m_l">简历设置：</div>
                            <div class="resume_r_yinsishezhi_main_m_r">对外开放</div>
                        </div>
                        <div class="resume_r_yinsishezhi_main_m row">
                            <div class="resume_r_yinsishezhi_main_m_l">屏蔽公司：</div>
                            <div class="resume_r_yinsishezhi_main_m_r">已屏蔽<span>3</span>个</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaResume',
    components: { NavTop, Footer },
    data() {
        return {
            fujianUrl: 'https://p.lietousaas.com/saas/zysp/resume/file',
            // fujianUrl: 'http://192.168.1.28:10000/saas/zysp/resume/file',
            zaixianjianli: {},
            guding: false,
            headers: {
                'Authorization': localStorage.getItem('Authorization'),// 假设token是从Vuex或者本地存储获取
            },
            uploadData: {
                fileName: '个人简历名称',
                parse: 0,
            },
            resumeFileList: [],
            resumeFileList2: [],
            fileLoading: false,
        }
    },
    mounted() {
        // 添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },
    activated() {
        // 简历列表
        this.getResumeFile();
        // 获取在线简历
        this.getResumeOnline();
    },
    methods: {
        // 获取在线简历
        async getResumeOnline() {
            let res = await this.$API.getResumeOnlineApi();
            console.log('获取在线简历-->', res);
            if (res.code == 0) {
                if (res.data) {
                    this.zaixianjianli = res.data;
                }
            }
        },
        handleScroll() {
            // 处理滚动事件
            // console.log(window.scrollY); // 输出当前滚动位置
            if (window.scrollY > 90) {
                this.guding = true;
            } else {
                this.guding = false;
            }
        },
        link(val) {
            if (val == 1) {
                window.scrollTo({
                    top: document.getElementById('gerenxinxi').offsetTop,
                    behavior: "smooth",
                });
            }
            if (val == 2) {
                window.scrollTo({
                    top: document.getElementById('gerenyoushi').offsetTop,
                    behavior: "smooth",
                });
            }
            if (val == 3) {
                window.scrollTo({
                    top: document.getElementById('qiwangzhiwei').offsetTop,
                    behavior: "smooth",
                });
            }
            if (val == 4) {
                window.scrollTo({
                    top: document.getElementById('gongzuojingli').offsetTop,
                    behavior: "smooth",
                });
            }
            if (val == 5) {
                window.scrollTo({
                    top: document.getElementById('xiangmujingli').offsetTop,
                    behavior: "smooth",
                });
            }
            if (val == 6) {
                window.scrollTo({
                    top: document.getElementById('jiaoyujingli').offsetTop,
                    behavior: "smooth",
                });
            }

            // let parent = document.getElementById('ceshi2');
            // // parent.scrollTop = target.offsetTop - parent.offsetTop;
            // // window.scrollTo(0, parent.offsetTop - 30);
            // window.scrollTo({
            //     top: parent.offsetTop - 30,
            //     behavior: "smooth",
            // });
        },
        // 隐私设置
        shezhi() {
            this.$router.push('/privacyset');
        },
        handleAvatarSuccess(res, file) {
            console.log('res, file-->', res, file);
            // this.info.avatarUrl = URL.createObjectURL(file.raw);
            if (res.code == 0) {
                this.$message.success('上传成功！');
                this.getResumeFile();
            }
        },
        beforeAvatarUpload(file) {
            console.log('file-->', file);
            this.uploadData.fileName = file.name;
            const isWord = file.type === 'application/msword';
            const isPDF = file.type === 'application/pdf';
            const isLt2M = (file.size / 1024 / 1024) < 20;
            if (!isWord && !isPDF) {
                this.$message.error('上传文件只能是 Word/PDF 格式！');
            }
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 20MB！');
            }
            return isLt2M;
        },
        // 简历列表
        async getResumeFile() {
            let res = await this.$API.getResumeFileApi();
            console.log('简历列表-->', res);
            if (res.code == 0) {
                this.resumeFileList = res.data;
            }
            if (res.data.length < 1) {
                this.uploadData.parse = 1;
            } else {
                this.uploadData.parse = 0;
            }
        },
        // 删除简历
        async fileDel(id) {
            let res = await this.$API.getResumeFileIdApi(id);
            console.log('删除简历-->', res);
            if (res.code == 0) {
                this.$message.success('删除成功！');
                this.getResumeFile();
            } else {
                this.$message.error(res.message);
            }
        },
        // 设置简历
        async shezhijianli(item) {
            this.fileLoading = true;
            try {
                let res = await this.$API.postResumeFileParseIdApi(item.id);
                console.log('设置简历-->', res);
                if (res.code == 0) {
                    // 获取在线简历
                    this.getResumeOnline();
                    this.$message.success('设置成功！');
                } else {
                    this.$message.error('设置失败！');
                }
                this.fileLoading = false;
            } catch (error) {
                // 获取在线简历
                this.getResumeOnline();
                this.fileLoading = false;
                this.$message.error('设置失败！');
            }
        },
        // 下载简历
        xiazaijianli(item) {
            console.log('下载简历-->', item);
            let link = document.createElement('a');
            link.href = item.fileUrl;
            link.setAttribute('download', item.fileName); // 文件名及扩展名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        // 重命名简历
        chongmingmingjianli(item) {
            console.log('重命名简历-->', item.fileName.lastIndexOf("."));
            console.log('重命名简历-->', item.fileName.substring(0, item.fileName.lastIndexOf(".")));

            this.$prompt('请输入你确定要修改的简历名称', '修改附件简历名称', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // inputPattern: /[^\a-zA-Z\u4E00-\u9FA5]/g,
                inputPattern: /^.{1,20}$/,
                inputErrorMessage: '只能输入1-20个字符',
                inputValue: item.fileName.substring(0, item.fileName.lastIndexOf(".")),
                closeOnClickModal: false,
            }).then(({ value }) => {
                if (value.length <= 10) {
                    let name = String(value) + '.' + item.fileType
                    this.postResumeFileName(name, item.id)
                } else {
                    this.$message.error('修改失败！');
                }
            }).catch(() => {

            });

        },
        // 调用重命名接口
        async postResumeFileName(filename, id) {
            this.fileLoading = true;
            try {
                let res = await this.$API.postResumeFileNameApi({ fileName: filename, id: id });
                console.log('调用重命名接口-->', res);
                if (res.code == 0) {
                    // 简历列表
                    this.getResumeFile();
                    this.$message.success('修改成功！');
                } else {
                    this.$message.error('修改失败！');
                }
                this.fileLoading = false;
            } catch (error) {
                this.$message.error('操作失败！');
                this.fileLoading = false;
            }
        }

    }

}
</script>

<style scoped>
.resume {
    width: 1200px;
    height: auto;
    margin: 20px auto;
    justify-content: space-between;
    position: relative;
}

.resume_l {
    width: 160px;
    height: 300px;
    background: #fff;
    border-radius: 10px;
}

.resume_l2 {
    width: 160px;
    height: auto;
    background: #fff;
    border-radius: 10px;
    position: fixed;
    top: 70px;
}

.resume_l_top {
    padding: 12px 20px;
    color: #222;
    font-weight: 600;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 10px 10px 0 0;
    font-size: 14px;
    line-height: 20px;
}

.resume_l_main {
    padding: 4px;
}

.resume_l_main_m {
    align-items: center;
    padding: 10px 16px;
    line-height: 20px;
    cursor: pointer;
    border-radius: 4px;
    transition: all .2s linear;
    color: #333;
}

.resume_l_main_m:hover {
    background-color: #f8f8f8;
    color: #00b277;
    font-weight: 600;
}

.resume_m {
    width: 720px;
    height: auto;
    background: #fff;
    border-radius: 10px;
}

.resume_m2 {
    width: 720px;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-left: 180px
}

.resume_m_top {
    height: 44px;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 10px 10px 0 0;
}

.resume_m_top_l {
    font-size: 14px;
    color: #999;
    font-weight: 400;
}

.resume_m_m {
    width: 660px;
    height: auto;
    padding: 20px 30px;
}

.resume_m_m2 {
    width: 660px;
    height: auto;
    padding: 20px 30px;
    text-align: center;
    font-size: 22px;
    color: #999;
    margin-top: 100px;
    margin-bottom: 300px;
}

.resume_m_m_gerenxinxi {
    justify-content: space-between;
}

.resume_m_m_gerenxinxi_l {
    padding: 8px;
}

.resume_m_m_gerenxinxi_l_name {
    color: #222;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 500;
}

.resume_m_m_gerenxinxi_l_jianjie {
    margin-top: 16px;
}

.resume_m_m_gerenxinxi_l_jianjie_m {
    line-height: 20px;
    height: 20px;
    min-width: 80px;
    max-width: 260px;
    margin-right: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
    font-size: 14px;
}

.resume_m_m_gerenxinxi_l_jianjie_m>i {
    margin-right: 8px;
    font-size: 16px;
    color: #999;
}


.resume_m_m_gerenxinxi_r {
    width: 80px;
    height: 80px;
}

.resume_m_m_gerenxinxi_r>img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
}

.resume_m_m_main {
    margin-top: 20px;
}

.resume_m_m_main_top {
    padding-left: 8px;
    height: 27px;
    line-height: 27px;
    margin-bottom: 12px;
}

.resume_m_m_main_top_l {
    width: 4px;
    height: 17px;
    background: #00b277;
    margin-top: 5px;
    margin-right: 10px;
    border-radius: 2px;
}

.resume_m_m_main_top_r {
    font-size: 20px;
    font-weight: 500;
}

.resume_m_m_main_m {}

.resume_m_m_main_m_gerenyoushi {
    padding: 8px;
    color: #333;
    line-height: 24px;
}

.resume_m_m_main_m_qiwangzhiwei {
    padding: 8px;
}

.resume_m_m_main_m_qiwangzhiwei_top {
    font-size: 14px;
    color: #999;
    line-height: 20px;
    padding: 0 16px;
    margin-bottom: 4px;
}

.resume_m_m_main_m_qiwangzhiwei_bottom {
    padding: 8px 16px;
}

.resume_m_m_main_m_qiwangzhiwei_bottom>span {
    color: #999;
}

.resume_m_m_main_m_qiwangzhiwei_bottom_zhiwei {
    max-width: 180px;
    padding-right: 12px;
    font-weight: 500;
    color: #222;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 14px;
}

.resume_m_m_main_m_qiwangzhiwei_bottom_xinzi {
    position: relative;
    display: inline-block;
    max-width: 100px;
    padding-right: 12px;
    padding-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    color: #333;
    font-size: 14px;
}

.resume_m_m_main_m_qiwangzhiwei_bottom_didian {
    color: #999;
    max-width: 154px;
    padding-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 14px;
}

.resume_m_m_main_m_gongzuojingli {
    padding: 8px;
    margin-bottom: 15px;
}

.resume_m_m_main_m_gongzuojingli_top {
    justify-content: space-between;
    margin-bottom: 8px;
}

.resume_m_m_main_m_gongzuojingli_top_l {}

.resume_m_m_main_m_gongzuojingli_top_title {
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
    display: inline-block;
    max-width: 240px;
    word-break: break-all;
}

.resume_m_m_main_m_gongzuojingli_top_job {
    margin-left: 16px;
    max-width: 200px;
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
    display: inline-block;
    word-break: break-all;
}

.resume_m_m_main_m_gongzuojingli_top_time {
    color: #999;
}

.resume_m_m_main_m_gongzuojingli_tabs {
    padding-top: 8px;
}

.resume_m_m_main_m_gongzuojingli_tabs_m {
    display: inline-block;
    padding: 2px 8px;
    margin-right: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    color: #444;
    line-height: 20px;
    background: rgba(0, 0, 0, .04);
    border-radius: 4px;
}

.resume_m_m_main_m_gongzuojingli_main {
    padding: 10px 0 0;
    color: #333;
    line-height: 24px;
    white-space: pre-wrap;
    overflow: hidden;
    word-break: break-all;
    text-align: justify;
    letter-spacing: 0;
}

.resume_m_m_main_m_gongzuojingli_main_l {
    font-weight: 600;
    color: #222;
    line-height: 24px;
    margin-right: 4px;
}

.resume_m_m_main_m_gongzuojingli_main_r {
    color: #333;
    line-height: 24px;
    white-space: pre-wrap;
    word-break: break-all;
    text-align: justify;
    letter-spacing: 0;
    flex: 1;
}

.resume_m_m_main_m_xiangmujingli {
    padding: 8px;
    margin-bottom: 15px;
}

.resume_m_m_main_m_xiangmujingli_top {
    justify-content: space-between;
    margin-bottom: 8px;
}

.resume_m_m_main_m_xiangmujingli_top_l {}

.resume_m_m_main_m_xiangmujingli_top_title {
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
    display: inline-block;
    max-width: 240px;
    word-break: break-all;
}

.resume_m_m_main_m_xiangmujingli_top_job {
    margin-left: 16px;
    max-width: 200px;
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
    display: inline-block;
    word-break: break-all;
}

.resume_m_m_main_m_xiangmujingli_top_time {
    color: #999;
}

.resume_m_m_main_m_xiangmujingli_main {
    padding: 10px 0 0;
    color: #333;
    line-height: 24px;
    white-space: pre-wrap;
    overflow: hidden;
    word-break: break-all;
    text-align: justify;
    letter-spacing: 0;
}

.resume_m_m_main_m_xiangmujingli_main_l {
    font-weight: 600;
    color: #222;
    line-height: 24px;
    margin-right: 4px;
}

.resume_m_m_main_m_xiangmujingli_main_r {
    color: #333;
    line-height: 24px;
    white-space: pre-wrap;
    word-break: break-all;
    text-align: justify;
    letter-spacing: 0;
    flex: 1;
}

.resume_m_m_main_m_jiaoyujingli {
    padding: 8px;
    margin-bottom: 15px;
}

.resume_m_m_main_m_jiaoyujingli_img {
    width: 48px;
    height: 48px;
}

.resume_m_m_main_m_jiaoyujingli_r {
    margin-left: 20px;
}

.resume_m_m_main_m_jiaoyujingli_r_top {}

.resume_m_m_main_m_jiaoyujingli_r_top_title {
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    max-width: 354px;
    word-break: break-all;
}

.resume_m_m_main_m_jiaoyujingli_r_top_time {
    display: inline-block;
    font-size: 14px;
    color: #999;
    line-height: 20px;
    margin-left: 16px;
}

.resume_m_m_main_m_jiaoyujingli_r_bottom {
    margin-top: 8px;
}

.resume_m_m_main_m_jiaoyujingli_r_bottom_l {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    float: left;
    padding-right: 8px;
    line-height: 20px;
    font-size: 14px;
    margin: 0;
    min-height: auto;
    color: #222;
}

.resume_m_m_main_m_jiaoyujingli_r_bottom_r {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    float: left;
    padding: 0 8px;
    line-height: 20px;
    font-size: 14px;
    margin: 0;
    min-height: auto;
    color: #222;
}

.resume_r {
    width: 280px;
    height: auto;
}

.resume_r_jianli {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
}

.resume_r_jianli_top {
    align-items: center;
    height: auto;
    padding: 12px 24px;
    line-height: 22px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 10px 10px 0 0;
    justify-content: space-between;
}

.resume_r_jianli_top_title {
    font-size: 16px;
    font-weight: 500;
    color: #222;
}

.resume_r_jianli_top i {
    font-weight: bolder;
    cursor: pointer;
    color: #7c7e85;
    border: 1px solid;
    border-radius: 4px;
    padding: 2px;
}

.resume_r_jianli_top i:hover {
    color: #00b277;
    border: 1px solid #00b277;
    border-radius: 4px;
    background: #fff;
    padding: 2px;
}

.resume_r_jianli_main {
    margin: 8px;
}

.resume_r_jianli_main_text {
    color: #333;
    font-size: 13px;
    font-weight: 500;
    padding: 8px 12px;
    line-height: normal;
}

.resume_r_jianli_main_file_wu {
    width: 100%;
    text-align: center;
}

.resume_r_jianli_main_file {
    color: #333;
    font-size: 14px;
    border-radius: 8px;
    transition: all .2s linear;
    padding: 8px 0px 8px 0px;
    cursor: pointer;
}

.resume_r_jianli_main_file:hover {
    background: #f7f7f7;
}

.resume_r_jianli_main_file_img {
    height: 44px;
    margin-right: 8px;
}

.resume_r_jianli_main_file_r {
    flex: 10;
}

.resume_r_jianli_main_file_title {
    line-height: 24px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}

.resume_r_jianli_main_file_xiangqing {
    font-size: 12px;
    line-height: 17px;
    color: #8d92a1;
}

.resume_r_jianli_main_file_more {
    position: relative;
    justify-content: center;
}

.resume_r_jianli_main_file_more:hover .resume_r_jianli_main_file_more_list {
    display: block;
}

.resume_r_jianli_main_file_more:hover .resume_r_jianli_main_file_more_dian {
    color: #00b277;
}

.resume_r_jianli_main_file_more_dian {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    line-height: 17px;
    font-size: 20px;
    color: #a9adb7;
    font-weight: bold;
}

.resume_r_jianli_main_file_more_list {
    display: none;
    position: absolute;
    z-index: 110;
    top: 34px;
    right: 0;
    background: #fff;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .08);
    border-radius: 8px;
    border: 1px solid #ededed;
    padding: 4px;
}

.resume_r_jianli_main_file_more_list_m {
    align-items: center;
    border-radius: 4px;
    color: #222;
    font-weight: 400;
    line-height: 20px;
    padding: 8px 12px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    transition: all .2s linear;
}

.resume_r_jianli_main_file_more_list_m:hover {
    color: #00b277;
    background: #f8f8f8;
}

.resume_r_yinsishezhi {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 20px;
}

.resume_r_yinsishezhi_top {
    align-items: center;
    height: auto;
    padding: 12px 24px;
    line-height: 22px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 10px 10px 0 0;
    justify-content: space-between;
}

.resume_r_yinsishezhi_top_l {
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 20px;
}

.resume_r_yinsishezhi_top_r {
    font-size: 14px;
    color: #56cbc4;
    cursor: pointer;
}

.resume_r_yinsishezhi_main {
    padding: 0 25px;
}

.resume_r_yinsishezhi_main_m {
    color: #414a60;
    padding: 15px 30px;
    margin: 0 -30px;
    line-height: 20px;
    justify-content: space-between;
}

.resume_r_yinsishezhi_main_m_l {
    color: #414a60;
    line-height: 20px;
}

.resume_r_yinsishezhi_main_m_r {
    float: right;
    font-size: 13px;
    color: #9fa3af;
}

.resume_r_yinsishezhi_main_m_r>span {
    color: #56cbc4;
}
</style>
